/**
 * 008 · i18n (R8, FR-020, GAP-3) — Normalización ligera de teléfono por país.
 *
 * Reemplaza el `normalizeWhatsapp` hardcodeado a Bolivia. País por defecto **BO** (respeta
 * "Bolivia único en MVP"), pero configurable vía `weddings.country_code`. Sin `libphonenumber-js`
 * (evita ~145 KB de bundle → LCP mobile-first). Reglas simples por país: código de marcación +
 * longitud del número local. Devuelve el número en formato `wa.me` (solo dígitos, con país) o null.
 */
export interface CountryPhoneRule {
  /** Código de marcación sin '+'. */
  dialCode: string;
  /** Dígitos del número local (sin el código de país). */
  localLength: number;
}

export const PHONE_RULES: Record<string, CountryPhoneRule> = {
  BO: { dialCode: '591', localLength: 8 },
  AR: { dialCode: '54', localLength: 10 },
  CL: { dialCode: '56', localLength: 9 },
  PE: { dialCode: '51', localLength: 9 },
  PY: { dialCode: '595', localLength: 9 },
  UY: { dialCode: '598', localLength: 8 },
  MX: { dialCode: '52', localLength: 10 },
  CO: { dialCode: '57', localLength: 10 },
  EC: { dialCode: '593', localLength: 9 },
};

export const DEFAULT_COUNTRY = 'BO';

export function normalizePhone(raw: string, country: string = DEFAULT_COUNTRY): string | null {
  const rule = PHONE_RULES[country] ?? PHONE_RULES[DEFAULT_COUNTRY];
  const digits = (raw ?? '').toString().replace(/\D/g, '');
  if (!digits) return null;

  // Ya viene con el código de país.
  if (digits.startsWith(rule.dialCode) && digits.length === rule.dialCode.length + rule.localLength) {
    return digits;
  }
  // Número local sin código de país.
  if (digits.length === rule.localLength) {
    return rule.dialCode + digits;
  }
  return null;
}
